// Warenkorb-Rückfrage (23.10.2026): Ist ein Gerät gemerkt („Meine Geräte“, gleicher Speicher wie
// assets/rxk-geraete.js) und liegt eine Variante für ein ANDERES Gerät derselben Gruppe im Warenkorb,
// erscheint oben in der Lade und auf der Warenkorbseite ein ruhiger Hinweis. Kein Blockieren –
// Geschenke für andere sind ja richtig. Seit 23.10.2026 für alle.
(() => {
  const S = document.currentScript;

  const gruppe = (m) => (/^iPhone/i.test(m) ? 'iphone' : /^MacBook/i.test(m) ? 'mac' : /^iPad/i.test(m) ? 'ipad' : /^iMac/i.test(m) ? 'imac' : '');
  const lesen = (s, k) => { try { return JSON.parse(s.getItem(k)); } catch { return null; } };
  const aktive = () => {
    if (sessionStorage.getItem('rxk-geraete-aus') === '1') return {};
    const d = lesen(sessionStorage, 'rxk-geraete-gast') || lesen(localStorage, 'rxk-geraete') || {};
    return d.aktiv && typeof d.aktiv === 'object' ? d.aktiv : {};
  };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let befund = null, laeuft = false;

  const pruefen = async () => {
    if (laeuft) return; laeuft = true;
    try {
      const akt = aktive();
      befund = null;
      if (Object.values(akt).some(Boolean)) {
        const c = await (await fetch(root + 'cart.js', { cache: 'no-store' })).json();
        outer: for (const it of c.items || []) for (const o of it.options_with_values || []) {
          const g = gruppe(String(o.value));
          if (g && akt[g] && akt[g] !== o.value) { befund = { g: akt[g], w: o.value }; break outer; }
        }
      }
      einsetzen();
    } catch {} finally { laeuft = false; }
  };

  const baue = () => {
    const p = document.createElement('p');
    p.className = 'rxk-wk-geraet';
    p.dataset.sig = befund.g + '|' + befund.w;
    const t = (S.dataset.text || '').replace('__G__', befund.g).replace('__W__', befund.w);
    const s = document.createElement('span'); s.textContent = t + ' ';
    const a = document.createElement('a'); a.href = S.dataset.finder || '/pages/geraete-finder'; a.textContent = S.dataset.link || '';
    p.append(s, a);
    p.style.cssText = 'margin:0 0 12px;padding:10px 12px;border:1px solid #111;font-size:13px;line-height:1.4;background:#fff;color:#111';
    a.style.cssText = 'color:inherit;text-decoration:underline;text-underline-offset:3px;white-space:nowrap';
    return p;
  };
  const einsetzen = () => {
    // Lade: oben in die Artikelliste; Warenkorbseite: direkt vor die Artikel (unter „Warenkorb“)
    const plaetze = [];
    const lade = document.querySelector('#cart-drawer .cart-drawer__items');
    if (lade) plaetze.push([lade, (h) => lade.prepend(h), lade.querySelector(':scope > .rxk-wk-geraet')]);
    const liste = document.querySelector('main .cart-items');
    if (liste) { const vor = liste.previousElementSibling; plaetze.push([liste, (h) => liste.before(h), vor && vor.classList.contains('rxk-wk-geraet') ? vor : null]); }
    for (const [, setzen, da] of plaetze) {
      if (!befund) { if (da) da.remove(); continue; }
      if (da && da.dataset.sig === befund.g + '|' + befund.w) continue;
      if (da) da.remove();
      setzen(baue());
    }
  };

  // Lade und Warenkorbseite werden von Horizon neu gezeichnet -> beobachten, kurz bündeln, nur bei neuer Lade-Fassung prüfen
  let t = 0, letzteLade = null;
  new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(() => {
      const lade = document.querySelector('#cart-drawer .cart-drawer__items');
      if (lade && lade !== letzteLade) { letzteLade = lade; pruefen(); } else einsetzen();
    }, 250);
  }).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pruefen); else pruefen();
})();
